export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_01.6fa59f03.jpg";